/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSaveCardSession200ResponseAnyOfIntent
 */
export interface CreateSaveCardSession200ResponseAnyOfIntent {
}

/**
 * Check if a given object implements the CreateSaveCardSession200ResponseAnyOfIntent interface.
 */
export function instanceOfCreateSaveCardSession200ResponseAnyOfIntent(value: object): value is CreateSaveCardSession200ResponseAnyOfIntent {
    return true;
}

export function CreateSaveCardSession200ResponseAnyOfIntentFromJSON(json: any): CreateSaveCardSession200ResponseAnyOfIntent {
    return CreateSaveCardSession200ResponseAnyOfIntentFromJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseAnyOfIntentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSaveCardSession200ResponseAnyOfIntent {
    return json;
}

export function CreateSaveCardSession200ResponseAnyOfIntentToJSON(json: any): CreateSaveCardSession200ResponseAnyOfIntent {
    return CreateSaveCardSession200ResponseAnyOfIntentToJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseAnyOfIntentToJSONTyped(value?: CreateSaveCardSession200ResponseAnyOfIntent | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

